export default class CreateInvoiceSeq{
    clientCode:string;
    length:number=1;
    fromNumber:number=1;
    endNumber:number=1;
}